// Exibe as mensagens de flash (shared/_flash) como toasts do SweetAlert2.
export function initFlashToasts(Swal) {
  document.querySelectorAll(".flash-message").forEach((el) => {
    const icon = el.dataset.flashIcon || "info";
    const message = el.dataset.flashMessage;
    if (message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom",
        width: "50%",
        animation: false,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
      Toast.fire({ icon: icon, text: message });
    }
    el.remove();
  });
}
